export const taxRateBefore20191001 = "0.08";
export const taxRateAfter20191001 = "0.10";
export const taxChangeBorder = "2019-09-29"

export const bedPrice = 3000;

export const mealPrice = {
  dinner : {
    adult: 1800,
    junior: 1400,
    kids: 1100
  },
  breakfast : {
    adult: 800,
    junior: 600,
    kids: 500
  }

};

export const roomPlans = [
  {
    "name": "A",
    "capacity" : 2,
    "basePrice": {
      "大人": 10000,
      "ジュニア" : 8600,
      "キッズ": 7600,
      "素泊り": 6000
    }
  },
  {
    "name": "B",
    "capacity" : 2,
    "basePrice": {
      "大人": 10000,
      "ジュニア" : 8600,
      "キッズ": 7600,
      "素泊り": 6000
    }
  },
  {
    "name": "D",
    "capacity" : 3,
    "basePrice": {
      "大人": 10000,
      "ジュニア" : 8600,
      "キッズ": 7600,
      "素泊り": 6000
    }
  },
  {
    "name": "F",
    "capacity" : 4,
    "basePrice": {
      "大人": 10000,
      "ジュニア" : 8600,
      "キッズ": 7600,
      "素泊り": 6000
    }
  },
  {
    "name": "I",
    "capacity" : 4,
    "basePrice": {
      "大人": 10000,
      "ジュニア" : 8600,
      "キッズ": 7600,
      "素泊り": 6000
    }
  },
  {
    "name": "J",
    "capacity" : 4,
    "basePrice": {
      "大人": 8400,
      "ジュニア" : 7700,
      "キッズ": 6800,
      "素泊り": 5200
    }
  },
  {
    "name": "Cottage",
    "capacity" : 2.5,
    "basePrice": {
      "大人": 11000,
      "ジュニア" :  8600,
      "キッズ": 7600,
      "素泊り": 6000
    }
  }
];

export const roomNames = roomPlans.map(room => (room.name));

export const roomTypes = {
  "twin" : {
      "name" : "ツインルーム（シャワールーム・トイレ付）",
      "rooms" : ["A", "B"]
    },
  "triple" : {
      "name" : "トリプルルーム（シャワールーム・トイレ付）",
      "rooms" : ["D"]
    },
  "quartette" : {
      "name" : "カルテットルーム（バスルーム・トイレ付）",
      "rooms" : ["F", "I"]
    },
  "regular" : {
      "name" : "レギュラールーム（バスルーム・トイレ無し）",
      "rooms" : ["J"]
    },
  "cottage" : {
      "name" : "コテージ（バスルーム・トイレ付)",
      "rooms" : ["Cottage"]
    }
};
